module.exports = __webpack_public_path__ + "img/tayaya-angradoce.21c7eb71.jpg";